export class EntityLinkInput {
  id?: string;
  outwardEntityId: string;
  outwardEntityType: string;
  inwardEntityId: string;
  inwardEntityType: string;
  linkType: string;
  role?: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.outwardEntityId = payload.outwardEntityId;
      this.outwardEntityType = payload.outwardEntityType;
      this.inwardEntityId = payload.inwardEntityId;
      this.inwardEntityType = payload.inwardEntityType;
      this.linkType = payload.linkType;
      this.role = payload.role;
    }
  }

}
